<template v-cloak>
  <div class="card card--skeleton" v-for="(i) in amount" :key="i" aria-hidden="true">
    <header>
      <div class="card--skeleton__line"></div>
      <div class="card--skeleton__line chip"></div>
    </header>
    <footer>
      <div class="card--skeleton__line"></div>
    </footer>
    <Icon icon="arrow-right" />
  </div>
</template>
<script>

import { defineComponent } from 'vue';
import Icon from "./Icon.vue";

export default defineComponent( {
  name: 'SkeletonCard',
  components: { Icon },
  props: {
    amount: {
      type: Number,
      default: 3,
    },
  },
} );
</script>
